// swiper
import Swiper from "swiper";
import { Navigation, FreeMode } from "swiper/modules";

// Helper function to initialize swipers
export const initializeSwiper = (elements, baseClassName, overrideConfig = {}) => {
  elements.forEach((element, index) => {
    const swiperNumber = index + 1;
    const containerClass = `${baseClassName}-container-${swiperNumber}`;

    element.classList.add(containerClass);
    const swiperClassEl = document.querySelector(`.${containerClass}`);
    const nextEl = swiperClassEl.querySelector(".swiper-button-next");
    const prevEl = swiperClassEl.querySelector(".swiper-button-prev");

    // Add null checks for navigation elements
    if (nextEl) {
      nextEl.classList.add(`swiper-button-next-${swiperNumber}`);
    }
    if (prevEl) {
      prevEl.classList.add(`swiper-button-prev-${swiperNumber}`);
    }

    // Count the actual slides
    const slides = swiperClassEl.querySelectorAll(".swiper-slide");
    const slideCount = slides.length;

    // Only enable loop if we have enough slides
    const shouldEnableLoop = slideCount > 4;

    // Adjust slidesPerView based on slide count
    const slidesPerView = slideCount === 1 ? 1 : "auto";

    const swiper = new Swiper(`.${containerClass}`, {
      modules: [Navigation, FreeMode],
      direction: "horizontal",
      slidesPerView: slidesPerView,
      spaceBetween: 24,
      loop: shouldEnableLoop,
      a11y: {
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
      },
      navigation: {
        nextEl: `.swiper-button-next-${swiperNumber}`,
        prevEl: `.swiper-button-prev-${swiperNumber}`,
      },
      ...overrideConfig,
    });

    // Handle autoplay interaction
    const nextButton = swiperClassEl.querySelector(`.swiper-button-next-${swiperNumber}`);
    const prevButton = swiperClassEl.querySelector(`.swiper-button-prev-${swiperNumber}`);

    // Log swiper configuration for debugging
    console.log(`Swiper ${containerClass}: ${slideCount} slides, loop: ${shouldEnableLoop}`);
  });
};

// Initialize event swipers
initializeSwiper(document.querySelectorAll(".swiper-pioniers"), "swiper-pioniers");
initializeSwiper(document.querySelectorAll(".swiper-objecten"), "swiper-objecten");
initializeSwiper(document.querySelectorAll(".swiper-ontdek"), "swiper-ontdek");
initializeSwiper(document.querySelectorAll(".swiper-afbeeldingen-slider"), "swiper-afbeeldingen-slider", {
  freeMode: true,
  freeModeMomentum: true,
  freeModeSticky: false,
  centeredSlides: false,
});
initializeSwiper(document.querySelectorAll(".swiper-text-slider"), "swiper-text-slider");
